import { AlertMessage } from "./AlertMessage";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../state";
import { useTranslation } from 'react-i18next';

export const AlertContainer: React.FC = () => {
    const {t} = useTranslation();
    const error = useSelector((state: RootState) => state.errorState);
    if (!error.title) return null;
    return (
                <AlertMessage type={"error"} title={t('error.serverError')} closable={true} className="ml-4 mr-4"/>
    );
};


